import React, { useEffect, useState } from 'react'
import { Button, Form, InputGroup, Modal } from 'react-bootstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import ToolkitProvider from 'react-bootstrap-table2-toolkit';
import { useTranslation } from 'react-i18next';
import { generateUanatacaStatusUri, getManagementSignature } from '../../../services/signatureMethods/customServiceSignature';
import Utils from '../../../services/Utils';

import plusIcon from '../../../assets/icons/plus-button.png';
import minusIcon from '../../../assets/icons/minus.png';

const UanatacaCertificates = ({ parentState, onAuthorizeUanatacaCertificate, onUnauthorizeUanatacaCertificate, children }) => {
  const { t } = useTranslation();
  const {
    certificatesOrdered: { Uanataca },
  } = parentState;
  const [showAuthorizeModal, setShowAuthorizeModal] = useState(false);

  const getColumns = () => {
    let uanatacaColumns = [
      {
        dataField: 'certalias',
        text: t('certificates.certificate'),
        align: 'left',
        sort: true,
        headerAlign: 'left',
        headerClasses: 'headerClass1',
        style: { verticalAlign: 'middle' }
      },
      {
        dataField: 'ExpirationDate',
        text: t('certificates.certificate-date'),
        align: 'left',
        sort: true,
        headerAlign: 'left',
        headerClasses: 'headerClass2',
        style: { verticalAlign: 'middle' }
      }
    ];
    if (Uanataca[0]?.AuthenticationType === 'OTP' || Uanataca[0]?.DN) {
      uanatacaColumns = [
        {
          dataField: 'DN',
          text: t('certificates.certificate'),
          align: 'left',
          sort: true,
          headerAlign: 'left',
          headerClasses: 'headerClass1',
          style: { verticalAlign: 'middle' }
        },
        {
          dataField: 'ExpirationDate',
          text: t('certificates.certificate-date'),
          align: 'left',
          sort: true,
          headerAlign: 'left',
          headerClasses: 'headerClass2',
          style: { verticalAlign: 'middle' }
        }
      ];
    }

    return uanatacaColumns;
  }

  if (Uanataca.length === 0) {
    Uanataca.push({
        GUID: 'placeholder',
        certalias: '---',
        ExpirationDate: '---',
        DN: '---',
    })
  }

  const [UTuser, setUTuser] = useState('');
  const [UTpassword, setUTpassword] = useState('');
  const [isAuthorized, setIsAuthorized] = useState(Uanataca.length);

  const getUanatacaStatus = () => {
    const oauthTokenB64 = sessionStorage.getItem('oauthTokenB64');
    const vidmobileUserGuid = Utils.getViDMobileUserGUIDFromOauthToken(oauthTokenB64);

    getManagementSignature(generateUanatacaStatusUri(vidmobileUserGuid), "", oauthTokenB64)
    .then((response) => {
      const { IsAuthorized } = response.data;

      setIsAuthorized(IsAuthorized);
    });
  }

  useEffect(getUanatacaStatus, []);

  return (
    <div className="table-container">
      <div>
        <div className='table-container-header'>
          {isAuthorized ? (
            <button
              className="new-create-button"
              onClick={onUnauthorizeUanatacaCertificate}
            >
              <img src={minusIcon} alt="minus icon" />
              <span>{t("general.unauthorize")}</span>
            </button>
          ) : (
            <button
              className="new-create-button"
              onClick={() => setShowAuthorizeModal(true)}
            >
              <img src={plusIcon} alt="plus icon" />
              <span>{t("general.authorize")}</span>
            </button>
          )}
          {isAuthorized && children}
        </div>
        {isAuthorized && (
          <div>
            <ToolkitProvider
              keyField="GUID"
              data={Uanataca}
              columns={getColumns()}
            >
              {(props) => (
                <div>
                  <BootstrapTable striped {...props.baseProps} />
                </div>
              )}
            </ToolkitProvider>
          </div>
        )}
        <Modal
          show={showAuthorizeModal}
          onHide={() => setShowAuthorizeModal(false)}
        >
          <Modal.Header closeButton>
            <Modal.Title>{t("general.authorize")}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <InputGroup className="mb-3">
              <InputGroup.Prepend>
                <InputGroup.Text id="uanataca-user">
                  {t("general.user")}
                </InputGroup.Text>
              </InputGroup.Prepend>
              <Form.Control
                required
                type="text"
                aria-label="Default"
                aria-describedby="uanataca-user"
                value={UTuser}
                onChange={(e) => setUTuser(e.target.value)}
              />
            </InputGroup>
            <InputGroup className="mb-3">
              <InputGroup.Prepend>
                <InputGroup.Text id="uanataca-password">
                  {t("general.password")}
                </InputGroup.Text>
              </InputGroup.Prepend>
              <Form.Control
                required
                type="password"
                aria-label="Default"
                aria-describedby="uanataca-password"
                value={UTpassword}
                onChange={(e) => setUTpassword(e.target.value)}
              />
            </InputGroup>
          </Modal.Body>
          <Modal.Footer>
            <Button
              type="button"
              id="authorizeUT"
              className="btn btn-primary signature-image"
              onClick={() => {
                setShowAuthorizeModal(false);
                onAuthorizeUanatacaCertificate({ UTuser, UTpassword })
              }}
            >
              {t("general.confirm")}
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </div>
  );
}

export default UanatacaCertificates